'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { WmtAppPlatform } from '@/lib/wmtAppPlatform/constants'

export type WmtAppPlatformContextValue = {
    platform: WmtAppPlatform | null
    storefrontOrigin: string
}

const WmtAppPlatformContext = createContext<WmtAppPlatformContextValue>({
    platform: null,
    storefrontOrigin: '',
})

/**
 * Hydrated once by the root layout from the server-read `wmt-app-platform` cookie
 * and request origin so client href rewrites match SSR.
 */
export function WmtAppPlatformProvider({
    platform,
    storefrontOrigin,
    children,
}: WmtAppPlatformContextValue & { children: ReactNode }) {
    return (
        <WmtAppPlatformContext.Provider value={{ platform, storefrontOrigin }}>
            {children}
        </WmtAppPlatformContext.Provider>
    )
}

export function useWmtAppPlatformContext(): WmtAppPlatformContextValue {
    return useContext(WmtAppPlatformContext)
}
